import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Checkbox,
  Button,
  Autocomplete,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import useAfasData from '../hooks/useAfasData';
import ArticleSelector from './ArticleSelector';

const OfferteRegels = ({ rows, setRows, debtorId }) => {
  console.log({ rows });

  const [modalOpen, setModalOpen] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  // const opmerkingenOpties = ['250 mL dubbel ged.', '500 mL standaard', 'Extra massa ingangscontrole']; // Replace with fetched data

  const { data: codeList = [], isLoading } = useAfasData('/articles');
  const { data: devices = [], isDevicesLoading } = useAfasData('/devices', { debtorId });
  console.log({ devices });

  const handleCodeChange = (index, newCode) => {
    if (newCode) {
      // Find the selected code details from the codeList
      const selectedCode = codeList.find((code) => code.Itemcode === newCode);
      console.log({ selectedCode });
      // Update the row's values based on the selected code
      const updatedRows = rows.map((row, rowIndex) => {
        if (rowIndex === index) {
          return {
            ...row,
            code: selectedCode.Itemcode,
            unit: selectedCode.Basiseenheid,
            type: selectedCode.Type_item_omschrijving,
            description: selectedCode.Omschrijving,
            remarks: selectedCode.Omschrijving,
            pricePerUnit: selectedCode.Basisverkooprijs ? selectedCode.Basisverkooprijs : 0,
            total: (selectedCode.Basisverkooprijs ? selectedCode.Basisverkooprijs : 0 * row.amount).toFixed(
              2
            ),
          };
        }
        return row;
      });
      console.log(updatedRows);
      setRows(updatedRows);
    }
  };
  // console.log(rows[activeRow]);

  const addRow = () => {
    setRows([
      ...rows,
      {
        type: '',
        code: '',
        unit: '',
        description: '',
        amount: 0,
        billable: true,
        remarks: '',
        pricePerUnit: 0.0,
        total: 0.0,
      },
    ]);
  };

  const deleteRow = (index) => {
    const newRows = rows.filter((row, i) => i !== index);
    setRows(newRows);
  };

  const handleRowChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;

    // Calculate the total for the row based on pricePerUnit * amount
    if (field === 'amount' || field === 'pricePerUnit') {
      newRows[index].total = (newRows[index].pricePerUnit * newRows[index].amount).toFixed(2);
    }

    setRows(newRows);
  };

  return (
    <div style={{ padding: '16px' }}>
      <h3 style={{ color: '#3f51b5', marginBottom: '16px' }}>Detail</h3>
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 120 }}>Code</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Type</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Eenheid</TableCell>
              <TableCell sx={{ minWidth: 120 }}>VSL Omschrijving VC</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Aantal</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Doorbelasten</TableCell>
              <TableCell sx={{ minWidth: 120 }}>VSL Opmerking VC</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Prijs per eenheid</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Bedrag</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Actie</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Autocomplete
                    options={codeList}
                    getOptionLabel={(option) => option.Itemcode || ''}
                    loading={isLoading}
                    value={row.Itemcode}
                    onChange={(event, newValue) => handleCodeChange(index, newValue?.Itemcode)}
                    renderInput={(params) => (
                      <TextField {...params} label="Code" size="small" variant="outlined" />
                    )}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    variant="outlined"
                    size="medium"
                    value={row.type}
                    onChange={(e) => handleRowChange(index, 'type', e.target.value)}
                  />
                </TableCell>
                {/* Autocomplete for Code */}

                <TableCell>
                  <TextField
                    variant="outlined"
                    // size="small"
                    value={row.unit}
                    onChange={(e) => handleRowChange(index, 'unit', e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    variant="outlined"
                    // size="small"
                    value={row.description}
                    onChange={(e) => handleRowChange(index, 'description', e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    variant="outlined"
                    // size="small"
                    value={row.amount}
                    onChange={(e) => handleRowChange(index, 'amount', parseInt(e.target.value))}
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={row.billable}
                    onChange={(e) => handleRowChange(index, 'billable', e.target.checked)}
                  />
                </TableCell>
                <TableCell>
                  {/* <TextField
                    variant="outlined"
                    size="medium"
                    value={row.remarks}
                    onChange={(e) => handleRowChange(index, 'remarks', e.target.value)}
                  /> */}
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={row.remarks}
                    onClick={() => {
                      setModalOpen(true);
                      setActiveRow(index);
                    }}
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    variant="outlined"
                    size="medium"
                    step="0.01"
                    value={row.pricePerUnit}
                    onChange={(e) => handleRowChange(index, 'pricePerUnit', parseFloat(e.target.value))}
                  />
                </TableCell>
                <TableCell>{row.total}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="medium"
                    onClick={() => deleteRow(index)}
                  >
                    Verwijder
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <ArticleSelector
          open={modalOpen}
          options={devices} // this should be an array of Gladior_Devices
          onClose={() => setModalOpen(false)}
          onSelect={(selectedDevice) => {
            const updated = rows.map((r, i) =>
              i === activeRow ? { ...r, remarks: selectedDevice.Dossieritem || '' } : r
            );
            setRows(updated);
          }}
          debtorId={debtorId}
          articleId={rows?.[activeRow]?.code ?? null}
        />
        {/* <ArticleSelector
          open={modalOpen}
          options={devices}
          loading={isDevicesLoading}
          onClose={() => setModalOpen(false)}
          onSelect={(selectedRemark) => {
            const newRows = [...rows];
            newRows[activeRowIndex].remarks = selectedRemark;
            setRows(newRows);
          }}
        /> */}
      </div>
      <Button variant="contained" color="primary" size="large" style={{ marginTop: '16px' }} onClick={addRow}>
        Voeg regel toe
      </Button>
    </div>
  );
};

export default OfferteRegels;
